import { useEffect } from 'react';
import toast from 'react-hot-toast';
import './index.scss';
import { useCameraViewContext } from '../../context';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Blocker = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  pointer-events: auto;
  animation: ${fadeIn} 0.2s ease-in;
  z-index: 99998;
`;

export const ImageLoading = () => {
  const { imageLoading, isVideoMode } = useCameraViewContext();

  useEffect(() => {
    if (!imageLoading || isVideoMode) {
      return;
    }
    const toastId = toast.loading(null, {
      className: 'image-loading',
      iconTheme: {
        primary: '#EEEEEE',
        secondary: '#3994DE'
      }
    });

    return () => {
      toast.dismiss(toastId);
    };
  }, [imageLoading]);

  if (!imageLoading || isVideoMode) return null;
  return <Blocker />;
};
